import BaseController from './basePlayerController';
import { OP_WRAPPER_LOCALIZATION_PREFIX } from '../../../utils/constants';
import { format } from '../../../utils/formatCurrency';

export default class ControllerWin extends BaseController {
  constructor({ container, ...props }) {
    super({ ...props });
    this._eElementsTypes = {
      EET_LABEL: 'label',
      EET_VALUE: 'value',
    };
    this._localizationKeys = {
      WIN: `${OP_WRAPPER_LOCALIZATION_PREFIX}.userInterface.win_label`,
      LAST_WIN: `${OP_WRAPPER_LOCALIZATION_PREFIX}.userInterface.win_label_last_win`,
      TOTAL_WIN: `${OP_WRAPPER_LOCALIZATION_PREFIX}.userInterface.total_win`,
    };
    this._localizations = {
      [this._eElementsTypes.EET_LABEL]: this._localizationKeys.WIN,
    };
    this._adaptiveElements = [this._eElementsTypes.EET_LABEL, this._eElementsTypes.EET_VALUE];

    this._lastWin = '';
    this._isTotalWinMode = false;
    this.init(container);
  }

  setValue(value) {
    if (this._isTotalWinMode) return;

    const numValue = Number(value);

    if (numValue) {
      this._showWin(numValue);
    } else {
      this._showLastWin();
    }
  }

  setTotalWin(value) {
    const formattedValue = Number(value) ? this._moneyFormat(Number(value)) : '';
    this.set(this._eElementsTypes.EET_VALUE, formattedValue);
    if (formattedValue) this._lastWin = formattedValue;
  }

  showTotalWin(value) {
    this._isTotalWinMode = true;

    this._localizations[this._eElementsTypes.EET_LABEL] = this._localizationKeys.TOTAL_WIN;
    this.set(this._eElementsTypes.EET_LABEL, this._getLocalization(this._localizations[this._eElementsTypes.EET_LABEL]));
    this.setTotalWin(value);
  }

  hideTotalWin() {
    this._isTotalWinMode = false;
    this._showLastWin();
  }

  setWinValue(value) {
    if (this._isTotalWinMode) return;

    const formattedValue = this._moneyFormat(Number(value));
    this._localizations[this._eElementsTypes.EET_LABEL] = this._localizationKeys.WIN;
    this.set(this._eElementsTypes.EET_LABEL, this._getLocalization(this._localizations[this._eElementsTypes.EET_LABEL]));
    this.set(this._eElementsTypes.EET_VALUE, formattedValue);
  }

  _showLastWin() {
    this._localizations[this._eElementsTypes.EET_LABEL] = this._localizationKeys.LAST_WIN;
    this.set(this._eElementsTypes.EET_LABEL, this._getLocalization(this._localizations[this._eElementsTypes.EET_LABEL]));
    this.set(this._eElementsTypes.EET_VALUE, this._lastWin);
  }

  _showWin(value) {
    const formattedValue = this._moneyFormat(value);
    this._lastWin = formattedValue;
    this._localizations[this._eElementsTypes.EET_LABEL] = this._localizationKeys.WIN;
    this.set(this._eElementsTypes.EET_LABEL, this._getLocalization(this._localizations[this._eElementsTypes.EET_LABEL]));
    this.set(this._eElementsTypes.EET_VALUE, formattedValue);
  }

  set lastWin(value) {
    this._lastWin = value ? this._moneyFormat(value) : '';
  }

  _getMarkup() {
    return `<div class="ui-container__title-desc-col ui-container__win_container">
          <label id=${this.interactiveElementsIds[this._eElementsTypes.EET_LABEL]}>
            ${this._getLocalization(this._localizations[this._eElementsTypes.EET_LABEL])}
          </label>
          <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_VALUE]}>
          </span>
        </div>`
  }
}
